(() => {
  const instances = new WeakMap();

  const initHeroVideo = (section) => {
    if (!section || instances.has(section)) return;

    const media = section?.querySelector('.chef-hero__media');
    const video = media?.querySelector('video');
    if (!video) return;

    const playHeroVideo = () => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.controls = false;
      video.disablePictureInPicture = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('aria-hidden', 'true');
      video.setAttribute('tabindex', '-1');

      if (!video.paused && !video.ended) {
        media.classList.add('is-playing');
        return;
      }

      video.play().then(() => {
        media.classList.add('is-playing');
      }).catch(() => {});
    };

    const handlePlaying = () => media.classList.add('is-playing');
    const handleVisibilityChange = () => {
      if (!document.hidden) playHeroVideo();
    };
    const interactionEvents = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
    const retryTimers = [250, 1000, 2000].map((delay) => window.setTimeout(playHeroVideo, delay));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', playHeroVideo, { once: true });
    } else {
      playHeroVideo();
    }

    video.addEventListener('loadedmetadata', playHeroVideo, { once: true });
    video.addEventListener('canplay', playHeroVideo, { once: true });
    video.addEventListener('playing', handlePlaying);
    window.addEventListener('pageshow', playHeroVideo, { once: true });
    document.addEventListener('visibilitychange', handleVisibilityChange);
    interactionEvents.forEach((eventName) => {
      document.addEventListener(eventName, playHeroVideo, { once: true, passive: true });
    });

    instances.set(section, () => {
      retryTimers.forEach((timer) => window.clearTimeout(timer));
      video.removeEventListener('playing', handlePlaying);
      window.removeEventListener('pageshow', playHeroVideo);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      interactionEvents.forEach((eventName) => {
        document.removeEventListener(eventName, playHeroVideo);
      });
      instances.delete(section);
    });
  };

  const cleanupHeroVideo = (section) => {
    const cleanup = instances.get(section);
    if (cleanup) cleanup();
  };

  document.querySelectorAll('[data-chef-hero-video-section]').forEach(initHeroVideo);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-chef-hero-video-section]').forEach(initHeroVideo);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-chef-hero-video-section]').forEach(cleanupHeroVideo);
  });
})();
